<template>
  <div class="currentcredit">
    <img src="../../assets/common/icon/mypoints-bg.png" alt="">
    <h2>当前积分：{{ userpointsmallcredit }}</h2>
  </div>
</template>

<script>
import { getuserpointsmall } from '@/api/user/index'
export default {
  name: 'usercredit',
  data () {
    return {
      userpointsmallcredit: 0
    }
  },
  mounted () {
    this.userpointsmall()
  },
  methods: {
    /* 我的积分 */
    userpointsmall () {
      getuserpointsmall(this.$cookie.get('culturalCloud_fid')).then(res => {
        // console.log(res)
        if (res.data.rel) {
          this.userpointsmallcredit = res.data.data.credit
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.currentcredit{
  text-align: center;
  img{
    width: 400px;
    height: 400px;
    margin: 0 auto;
    display: block;
  }
  h2{
    color: #cf0000;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/personalcenter/usercredit.vue